import { event } from '@uhg-abyss/web/tools/event';

export const widgetClickEvent = (input) => {
  const {
    componentId,
    componentLocation,
    componentName,
    componentType,
    destination,
  } = input;
  event('PSX_DETAILS_WIDGET_CLICK', {
    componentName: componentName?.toLowerCase().replaceAll('-', ''),
    componentId: componentId?.toLowerCase().replaceAll('-', ''),
    componentLocation: componentLocation?.toLowerCase().replaceAll('-', ''),
    componentType: componentType?.toLowerCase().replaceAll('-', ''),
    destination: destination?.toLowerCase().replaceAll('-', ''),
  });
};
